var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentReleased({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10344",
    "data-name": "Group 10344",
    transform: "translate(-29.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_266",
    "data-name": "Ellipse 266",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(29.5)",
    fill: "#01b762"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M4945.945,21763.895a3.163,3.163,0,0,1-3.157-3.162v-18.943a3.158,3.158,0,0,1,3.157-3.156h25.262a3.158,3.158,0,0,1,3.157,3.156v18.943a3.163,3.163,0,0,1-3.157,3.162Zm0-3.162h25.268l-.006-9.471h-25.262Zm0-15.785h25.262v-3.158h-25.262Zm3.157,12.633v-3.162h9.477v3.162Z",
    transform: "translate(-4896.576 -21718.266)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentReleased);
export default __webpack_public_path__ + "static/media/Payment Released.c19232d15355bf2b2cdb4e2074875cab.svg";
export { ForwardRef as ReactComponent };